import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import * as Unicons from "@iconscout/react-unicons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

const Profile = () => {
  const [passShow, setPassShow] = useState(false);
  const [confirmPassShow, setConfirmPassShow] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const userInfo = useSelector((state) => state?.userInfo?.userInfo);
  console.log(userInfo);
  useEffect(() => {
    if (userInfo) {
      setFormData((prev) => ({
        ...prev,
        name: userInfo.fname || "",
        email: userInfo.email || "",
      }));
    }
  }, [userInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const token = localStorage.getItem("usersdatatoken");
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.newPassword || !formData.confirmPassword) {
      toast.error("Please fill in both password fields");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (formData.newPassword.length < 6) {
      toast.error("Password should be at least 6 characters long");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACK_URL}/api/user/update-password`,
        { password: formData.newPassword },
        axiosConfig,
      );
      console.log("Password updated:", response.data);
      toast.success("Password updated successfully");
      setFormData((prev) => ({
        ...prev,
        newPassword: "",
        confirmPassword: "",
      }));
    } catch (error) {
      console.error(
        "Error updating password:",
        error.response ? error.response.data : error,
      );
      toast.error(
        error.response?.data?.message ||
          "An error occurred while updating password",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <ToastContainer />
      <div className="flex items-center justify-center py-10 bg-slate-100 min-h-[88vh]">
        <div className="bg-white rounded-2xl border shadow-xl p-10 w-full max-w-lg">
          <div className="mb-8">
            <h1 className="font-bold text-4xl text-gray-700 text-center">
              Edit Profile
            </h1>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="flex flex-col items-center space-y-4">
              {/* Name Field - Disabled */}
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600 mb-2 block">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  disabled
                  className="border-2 rounded-lg w-full h-12 px-4 focus:ring-0 focus:border-gray-500 bg-gray-100 text-gray-600 cursor-not-allowed"
                />
              </div>

              {/* Email Field - Disabled */}
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600 mb-2 block">
                  Email
                </label>
                <input
                  type="text"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  disabled
                  className="border-2 rounded-lg w-full h-12 px-4 focus:ring-0 focus:border-gray-500 bg-gray-100 text-gray-600 cursor-not-allowed"
                />
              </div>

              {/* New Password Field */}
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600 mb-2 block">
                  New Password
                </label>
                <div className="relative">
                  <input
                    onChange={handleChange}
                    type={!passShow ? "password" : "text"}
                    value={formData.newPassword}
                    name="newPassword"
                    id="newPassword"
                    placeholder={"Enter New Password"}
                    className="w-full border-2 rounded-lg h-12 px-4 block focus:ring-0 focus:border-gray-500"
                  />
                  <span
                    className="absolute inset-y-0 top-2 md:top-3 right-3 cursor-pointer"
                    onClick={() => setPassShow(!passShow)}
                  >
                    {!passShow ? (
                      <Unicons.UilEye color="gray" />
                    ) : (
                      <Unicons.UilEyeSlash color="gray" />
                    )}
                  </span>
                </div>
              </div>

              {/* Confirm Password Field */}
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600 mb-2 block">
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    onChange={handleChange}
                    type={!confirmPassShow ? "password" : "text"}
                    value={formData.confirmPassword}
                    name="confirmPassword"
                    id="confirmPassword"
                    placeholder={"Confirm Password"}
                    className="w-full border-2 rounded-lg h-12 px-4 block focus:ring-0 focus:border-gray-500"
                  />
                  <span
                    className="absolute inset-y-0 top-2 md:top-3 right-3 cursor-pointer"
                    onClick={() => setConfirmPassShow(!confirmPassShow)}
                  >
                    {!confirmPassShow ? (
                      <Unicons.UilEye color="gray" />
                    ) : (
                      <Unicons.UilEyeSlash color="gray" />
                    )}
                  </span>
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="bg-teal-500 text-white rounded-md hover:bg-teal-600 font-semibold px-4 py-3 w-full disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Updating..." : "Update Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
